import { render } from "./Branch.vue?vue&type=template&id=b945ba5e&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"

import "./Branch.vue?vue&type=style&index=0&id=b945ba5e&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b945ba5e"]])

export default __exports__